import {cloneDeep} from 'lodash';
import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
import {isApiResponseOk} from '../../util/utils';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function getItProcesses(state = initialState.engagementITProcesses, action) {
	function updateRelatedTask(payload, isSorting = false) {
		const itProcessIndex = state.data?.findIndex((itProcess) => itProcess.id === payload.itProcessId);
		if (itProcessIndex !== -1) {
			let updatedtasks = cloneDeep(state);
			updatedtasks.data[itProcessIndex].relatedTasks.push(payload);
			if (isSorting) {
				updatedtasks.data[itProcessIndex].relatedTasks.sort((a, b) => {
					const aValue = a.taskDisplayName || a.taskName;
					const bValue = b.taskDisplayName || b.taskName;
					return aValue.localeCompare(bValue, undefined, {numeric: true, sensivity: 'base'});
				});
			}
			updatedtasks.data[itProcessIndex].addTaskLoader = false;
			return updatedtasks;
		}
		return state;
	}

	switch (action.type) {
		case types.GET_IT_PROCESSES: {
			return action.response;
		}

		case types.GET_IT_UNRELATED_PROCESS:
			return state;

		case types.CLEAR_IT_PROCESSES:
			return initialState.engagementITProcesses;

		case types.SET_LOADER_FOR_RELATED_TASK: {
			if (action.itProcess) {
				return {
					...state,
					data: state.data.map((itProcess) => {
						if (itProcess.id === action.itProcess.id) {
							return {
								...itProcess,
								addTaskLoader: true
							};
						}
						return itProcess;
					})
				};
			}
			return state;
		}

		case types.ADD_RELATED_TASK:
			if (action.taskAttributes) {
				return updateRelatedTask(action.taskAttributes);
			}
			return state;

		case types.LINK_ITPROCESS_RELATE_TASK:
			if (action.taskAttributes && isApiResponseOk(action)) {
				return updateRelatedTask(action.taskAttributes, true);
			}
			return state;

		case types.UNLINK_ITPROCESS_RELATE_TASK:
			if (action.taskAttributes && isApiResponseOk(action)) {
				const itProcesses = cloneDeep(state);
				const itProcess = itProcesses?.data?.find((itProcess) => itProcess.id === action.taskAttributes.itProcessId);
				if (itProcess) {
					let relatedTaskIndex = itProcess.relatedTasks.findIndex(
						(task) => task.id === action.taskAttributes.taskId || task.taskId === action.taskAttributes.taskId
					);
					if (relatedTaskIndex !== -1) {
						itProcess.relatedTasks.splice(relatedTaskIndex, 1);
					}
				}
				return itProcesses;
			}
			return state;

		default:
			return state;
	}
}
